module.exports = __webpack_public_path__ + "static/ch1-timeline-kkk-a3ff2daf7870ebb211703bb35e641db7.png";